import React from 'react';
import { observer } from 'mobx-react';
import { Button, ButtonGroup, Popover, Menu, MenuItem, MenuDivider } from 'core/components';
import { FiRefreshCcw } from 'react-icons/fi';
import { PopoverPosition } from '@blueprintjs/core';

const AdminTableRefreshButton = ({
  buttonProps,
  setRefreshFrequency,
  onRefresh,
  loading,
  refreshFrequency,
  autoRefreshEnabled,
  setAutoRefresh,
  allowAutoRefresh
}) => {
  const handleChange = (newRefreshFrequency) => {
    if (newRefreshFrequency === 0) {
      setAutoRefresh(false);
    } else {
      setAutoRefresh(true);
      setRefreshFrequency(newRefreshFrequency);
    }
  };

  return (
    <ButtonGroup>
      <Button minimal loading={loading} icon={FiRefreshCcw} text="Refresh" {...buttonProps} onClick={onRefresh} />
      {allowAutoRefresh && (
        <Popover
          position={PopoverPosition.BOTTOM_RIGHT}
          content={
            <Menu minWidth={120}>
              <MenuDivider title="Auto Update" />
              <MenuItem text="Off" onClick={() => handleChange(0)} />
              <MenuItem text="1 Minute" onClick={() => handleChange(60 * 1000)} />
              <MenuItem text="2 Minutes" onClick={() => handleChange(2 * 60 * 1000)} />
              <MenuItem text="5 Minutes" onClick={() => handleChange(5 * 60 * 1000)} />
            </Menu>
          }
        >
          <Button
            {...buttonProps}
            minimal
            ml={0}
            rightIcon="caret-down"
            fontSize={12}
            text={
              autoRefreshEnabled && refreshFrequency
                ? `Every ${refreshFrequency / 60 / 1000} Minute${refreshFrequency > 60 * 1000 ? 's' : ''}`
                : undefined
            }
            intent={autoRefreshEnabled && refreshFrequency ? 'warning' : undefined}
            ariaIsMenuButton
          />
        </Popover>
      )}
    </ButtonGroup>
  );
};

export default observer(AdminTableRefreshButton);
